import { Colors } from '../Colors';

export default {
    styles: (_, props) => ({
        tab: {
            borderBottomWidth: '.25rem',
            padding: 'var(--mantine-spacing-xs) var(--mantine-spacing-xs)',
            marginRight: 'var(--mantine-spacing-sm)',
        },
        tabLabel: {
            fontSize: '1.125rem',
            color: props.selected ? Colors.primary : Colors.text,
        }
    }),
};
